<template>
  <div class="things-banner">
    <img :src="mobilethingsBanner" alt="" />
    <div class="absolute">
      <div class="title">物联网硬件系统</div>
      <div class="text">
        智慧物业通过智能感知硬件：无人门岗、人脸识别、车辆识别、水电煤监测、电梯监测、高空抛物监测、垃圾分类监控、访客自动登记、自动测温等。通过AI算法形成业务闭环，节约物业人工成本，打通软硬件壁垒，实现现代智能化物业管理的一种新型物管模式。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/mobile/components/Experience.vue";

import mobilethingsBanner from "../../../../assets/product/mobilethingsBanner.png";

export default {
  setup() {
    return reactive({
      mobilethingsBanner: mobilethingsBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.things-banner {
  position: relative;
}
.things-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #fff;
}
.absolute .text {
  font-size: 10px;
  margin-top: 12px;
  color: #fff;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 5px;
  color: #fff;
  border: 1px solid rgba(255,255,255, .8);
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
